import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { LONG } from 'shared/units/constants'
import {
  FormattedDistance,
  FormattedDuration,
  FormattedEnergy,
} from 'shared/units'

import {
  GOAL_TYPES,
} from '../shared/constants'

export default function FormattedGoal (props) {
  const { goalType, value } = props
  return (
    <span>
      {goalType === GOAL_TYPES.distance.key ?
        <FormattedDistance value={value} /> : null}

      {goalType === GOAL_TYPES.duration.key ?
        <FormattedDuration
          from={'second'}
          to={'hour'}
          unit={LONG}
          value={value} /> : null}

      {goalType === GOAL_TYPES.workouts.key ?
        <FormattedMessage
          id='goals.workouts.desc'
          defaultMessage={'{numOfWorkouts} {numOfWorkouts, plural, one {workout} other {workouts}}'}
          values={{
            numOfWorkouts: value.toString(),
          }} /> : null}

      {goalType === GOAL_TYPES.energy.key ?
        <FormattedEnergy
          value={value / 1000} /> : null}
    </span>
  )
}

FormattedGoal.propTypes = {
  goalType: PropTypes.string,
  value: PropTypes.number,
}



// WEBPACK FOOTER //
// ./src/components/goals/view/FormattedGoal.jsx